"use strict";

exports.__esModule = true;
exports.QAComponent = void 0;
var _react = require("@testing-library/react");
var _dom = require("@testing-library/dom");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var ComponentInstanceCache = new WeakMap();
var QAComponent = exports.QAComponent = /*#__PURE__*/function () {
  function QAComponent(parent, element) {
    var existing = ComponentInstanceCache.get(element);
    if (existing !== undefined) {
      return existing;
    }
    this.parent = parent;
    this.element = element;
    ComponentInstanceCache.set(element, this);
  }
  var _proto = QAComponent.prototype;
  _proto.get = function get(ChildComponent, selector) {
    if (selector === void 0) {
      selector = ChildComponent.getSelector();
    }
    var found = this.find(ChildComponent, selector);
    if (found == null) {
      throw new Error("Could not find a matching element for: " + selector + " in\n" + (0, _dom.prettyDOM)(this.element));
    }
    return found;
  };
  _proto.getAll = function getAll(ChildComponent, selector) {
    if (selector === void 0) {
      selector = ChildComponent.getSelector();
    }
    var found = this.findAll(ChildComponent, selector);
    if (found.length === 0) {
      throw new Error("Could not find a matching element for: " + selector + " in\n" + (0, _dom.prettyDOM)(this.element));
    }
    return found;
  };
  _proto.find = function find(ChildComponent, selector) {
    if (selector === void 0) {
      selector = ChildComponent.getSelector();
    }
    var element = this.element;
    var found = element.querySelector(selector);
    if (found == null) {
      return;
    }
    return new ChildComponent(this, found);
  };
  _proto.findAll = function findAll(ChildComponent, selector) {
    var _this = this;
    if (selector === void 0) {
      selector = ChildComponent.getSelector();
    }
    var element = this.element;
    var found = element.querySelectorAll(selector);
    return Array.from(found, function (node) {
      return new ChildComponent(_this, node);
    });
  };
  _proto.queryByTestId = function queryByTestId(input) {
    return this.element.querySelector("[data-testid='" + input + "']");
  };
  _proto.queryAllByTestId = function queryAllByTestId(input) {
    return this.element.querySelectorAll("[data-testid=\"" + input + "\"]");
  };
  _proto.getByTestId = function getByTestId(input) {
    var found = this.queryByTestId(input);
    if (found == null) {
      throw new Error("Cannot find an element with data-testid=\"" + input + "\" in\n" + (0, _dom.prettyDOM)(this.element));
    }
    return found;
  };
  _proto.getAllByTestId = function getAllByTestId(input) {
    var found = this.queryAllByTestId(input);
    if (found.length === 0) {
      throw new Error("Cannot find any elements with data-testid=\"" + input + "\" in\n" + (0, _dom.prettyDOM)(this.element));
    }
    return Array.from(found);
  };
  _proto.querySelector = function querySelector(input) {
    return this.element.querySelector(input);
  };
  _proto.querySelectorAll = function querySelectorAll(input) {
    return this.element.querySelectorAll(input);
  };
  _proto.getBySelector = function getBySelector(input) {
    var found = this.querySelector(input);
    if (found == null) {
      throw new Error("Cannot find an element with selector \"" + input + "\" in\n" + (0, _dom.prettyDOM)(this.element));
    }
    return found;
  };
  _proto.getAllBySelector = function getAllBySelector(input) {
    var found = this.querySelectorAll(input);
    if (found.length === 0) {
      throw new Error("Cannot find any elements with selector \"" + input + "\" in\n" + (0, _dom.prettyDOM)(this.element));
    }
    return Array.from(found);
  };
  _proto.getByName = function getByName(input) {
    var found = this.querySelector("[name=\"" + input + "\"]");
    if (found == null) {
      throw new Error("Cannot find an element with name=\"" + input + "\" in\n" + (0, _dom.prettyDOM)(this.element));
    }
    return found;
  };
  _proto.getAllByName = function getAllByName(input) {
    var found = this.querySelectorAll("[name=\"" + input + "\"]");
    if (found.length === 0) {
      throw new Error("Cannot find any elements with name=\"" + input + "\" in\n" + (0, _dom.prettyDOM)(this.element));
    }
    return Array.from(found);
  };
  QAComponent.getSelector = function getSelector() {
    return "[data-testid=\"" + this.componentName + "\"]";
  };
  QAComponent.mount = function mount(container, selector) {
    if (selector === void 0) {
      selector = this.getSelector();
    }
    if (container.matches(selector)) {
      return new this(undefined, container);
    }
    var found = container.querySelector(selector);
    if (found == null) {
      throw new Error("Could not find a matching dom node for: " + selector + " in\n" + (0, _dom.prettyDOM)(container));
    }
    return new this(undefined, found);
  };
  QAComponent.waitFor = /*#__PURE__*/function () {
    var _waitFor2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(container, selector) {
      var _this2 = this;
      var result;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (selector === void 0) {
              selector = this.getSelector();
            }
            _context.n = 1;
            return (0, _react.waitFor)(function () {
              return _this2.mount(container, selector);
            });
          case 1:
            result = _context.v;
            if (!(result == null)) {
              _context.n = 2;
              break;
            }
            throw new Error("Could not find a matching dom node for: " + selector + " in\n" + (0, _dom.prettyDOM)(container));
          case 2:
            return _context.a(2, result);
        }
      }, _callee, this);
    }));
    function waitFor(_x, _x2) {
      return _waitFor2.apply(this, arguments);
    }
    return waitFor;
  }();
  QAComponent.waitFor = /*#__PURE__*/function () {
    var _waitFor3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(container, selector) {
      var _this3 = this;
      var result;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            if (selector === void 0) {
              selector = this.getSelector();
            }
            _context2.n = 1;
            return (0, _react.waitFor)(function () {
              return _this3.mount(container, selector);
            });
          case 1:
            result = _context2.v;
            if (!(result == null)) {
              _context2.n = 2;
              break;
            }
            throw new Error("Could not find a matching dom node for: " + selector + " in\n" + (0, _dom.prettyDOM)(container));
          case 2:
            return _context2.a(2, result);
        }
      }, _callee2, this);
    }));
    function waitFor(_x3, _x4) {
      return _waitFor3.apply(this, arguments);
    }
    return waitFor;
  }();
  return QAComponent;
}();
QAComponent.componentName = "";